var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgArrowDown = function SvgArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 15.0823C17.0976 15.4728 17.0976 16.106 16.7071 16.4965L12.4966 20.7071C12.1061 21.0976 11.4729 21.0976 11.0824 20.7071L6.87184 16.4965C6.48132 16.106 6.48132 15.4728 6.87184 15.0823C7.26236 14.6918 7.89553 14.6918 8.28605 15.0823L11.7895 18.5857L15.2929 15.0823C15.6834 14.6918 16.3166 14.6918 16.7071 15.0823Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7896 3C12.3418 3 12.7896 3.44772 12.7896 4L12.7896 20C12.7896 20.5523 12.3418 21 11.7895 21C11.2373 21 10.7896 20.5523 10.7896 20L10.7896 4C10.7896 3.44772 11.2373 3 11.7896 3Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgArrowDown);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/ArrowDown.c7a41b44eb849c400cc38b5c11398bd3.svg";